import { Link, useLocation } from 'react-router-dom';
import { cn, buttonVariants, Button } from '@sib/ui';
import { MEDIA_SM_QUERY } from '@spendbrain/config/constants';
import { useMediaQuery } from '@spendbrain/hooks';
import { useSidebarStore } from '../../stores';
import { useSidebarItems } from './NavigationMenu.utils';

export const NavigationMenu = () => {
  const { pathname } = useLocation();
  const { setSidebarOpen } = useSidebarStore();
  const sidebarItems = useSidebarItems();
  const currentPathname = String(pathname);
  const isMobile = useMediaQuery(MEDIA_SM_QUERY);

  return (
    <div className="group flex flex-col justify-between gap-4">
      <nav className="grid gap-1">
        {(sidebarItems || []).map(({ href, title, icon: Icon, onClick }) => {
          const isActive = currentPathname.startsWith(href?.toString() ?? '/#');
          const className = cn(
            buttonVariants({
              variant: 'ghost',
            }),
            'text-primary justify-start rounded-none px-[18px] font-normal no-underline',
            isActive
              ? 'bg-secondary hover:text-primary font-medium hover:brightness-100'
              : 'hover:bg-muted hover:brightness-100'
          );
          const isExternal = href?.startsWith('http');

          return onClick ? (
            <Button
              variant="ghost"
              className={className}
              key={title}
              onClick={onClick}
            >
              <Icon className="size-[18px]" />
              {title}
            </Button>
          ) : (
            <Link
              key={href}
              to={href?.toString() ?? '/#'}
              title={title}
              onClick={onClick}
              target={isExternal ? '_blank' : undefined}
              rel={isExternal ? 'noopener noreferrer' : undefined}
              className={className}
              {...(isMobile && {
                onClick: () => setSidebarOpen(false),
              })}
            >
              <Icon className="size-[18px]" />
              {title}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

NavigationMenu.displayName = 'NavigationMenu';
